<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 6.5V2H22V22H13.5" stroke="currentColor" stroke-width="1.5" />
    <path d="M11 22V9H2V22H11Z" stroke="currentColor" stroke-width="1.5" />
    <path d="M5.75 19H7.25" stroke="currentColor" stroke-width="1.5" />
    <path d="M13.5 19H16.5" stroke="currentColor" stroke-width="1.5" />
  </svg>
</template>
